module.exports = __webpack_public_path__ + "static/img/tooltip-walker-constellations.5b1a2be.png";